import {
  DeclineIssueRequestDto,
  GetIssueResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeclineIssue({
  code,
  onSuccess,
}: {
  code: string;
  onSuccess: () => void;
}) {
  const api = useApi();

  const queryClient = useQueryClient();

  return useMutation<
    GetIssueResponseDto,
    ExtendedAxiosError,
    DeclineIssueRequestDto
  >({
    mutationKey: ['issues', code],
    mutationFn: (req) =>
      api.issuesApi.declineIssue(code, req).then((res) => res.data),
    onSuccess: async (response) => {
      queryClient.setQueryData<GetIssueResponseDto>(['issues', code], response);
      onSuccess();
    },
  });
}
